import React, { useContext } from 'react'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useHistory } from 'react-router-dom'

import { AddDoseForm } from '..'
import { MobileNavitagion } from './MobileNavigation'
import { WebNavigation } from './WebNavigation'
import { useDialog } from '../../providers/dialog-provider'
import { FirestoreContext } from '../../providers/firestore-provider'
import { useDispatch } from 'react-redux'
import { openSnackbar } from '../../ducks/snackbar/actions'

const Navigation = () => {
  const { openDialog, closeDialog } = useDialog()
  const history = useHistory()
  const { myCircles } = useContext(FirestoreContext)
  const dispatch = useDispatch()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const onOpenDoseModal = () => {
    openDialog({
      color: 'primary',
      title: 'Add a dose',
      confirmText: 'ADD',
      custom: true,
      description: (
        <AddDoseForm
          onAddDose={() => closeDialog()}
          onCancelDose={() => closeDialog()}
          toAllCircles
        />
      ),
      onClose: () => true,
      fullScreen: true,
    })
  }

  const handleMenuClick = (pageURL = '', modal = false) => {
    if (modal) {
      if (myCircles.length) return onOpenDoseModal()

      return dispatch(
        openSnackbar(
          'You need to add a group before adding doses. Please add a group.',
          'info',
          5000
        )
      )
    }
    return history.push(pageURL)
  }

  if (isMobile) {
    return (
      <MobileNavitagion
        onClickPlusItem={() => handleMenuClick('', true)}
        onClickMenuItem={handleMenuClick}
      />
    )
  }

  return <WebNavigation onClickMenuItem={handleMenuClick} />
}

export default Navigation
